import {
  IconButton,

} from "@mui/material";
import React, { Fragment, useContext, useState } from "react";
import {
  FiBox,
  FiEdit,

} from "react-icons/fi";
import { Terminal } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import styles from "./styles";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const TerminalListItem: React.FunctionComponent<{
  terminal: Terminal;
  onEdit: (terminal: Terminal) => void;

}> = (props) => {
  const [terminal] = useState(props.terminal);

  const session = useContext(SessionContext);
  const { t } = useTranslation();


  if (session.current.site == null) {
    return <Fragment />;
  }


  return (
    <Fragment>
      <div
        style={{ ...styles.bookingListItem, opacity: terminal.active == true ? 1 : 0.5 }}
      >
        <div
          style={{
            ...flex.flexRows,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={flex.flexAuto}>
            <div>
              <IconButton disabled={true}>
                <FiBox />
              </IconButton>
            </div>
          </div>
          <div style={{ ...flex.flexFill, textAlign: "left" }}>
            <div>
              <b>
                {terminal.name}
              </b>
            </div>

          </div>



          <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>

            <IconButton
              onClick={() => {
                props.onEdit(terminal);
              }}
            >
              <FiEdit />
            </IconButton>
            <div>
              <small>{t("general.edit")}</small>
            </div>

          </div>



        </div>
      </div>
    </Fragment>
  );
};

TerminalListItem.propTypes = {
  terminal: propTypes.any.isRequired,
  onEdit: propTypes.func.isRequired
};

export default TerminalListItem;
